import type { VoidFunctionComponent } from 'react';

import { Icon, icons } from '../../../generic';

import styles from './IndeterminateGit.module.less';

const IndeterminateGit: VoidFunctionComponent = () => {
  return (
    <div className={styles.indeterminate}>
      <span className={styles.iconWrapper}>
        <Icon icon={icons.hourglassO} size="fa-3x" />
      </span>
      <div className={styles.header}>
        <p>We couldn&apos;t validate this package in time</p>
      </div>
      <div className={styles.message}>
        <p>
          Git dependencies can take longer to analyze. You can still add this
          dependency, or update the details and try again.
        </p>
      </div>
    </div>
  );
};

export default IndeterminateGit;
